import React, { useMemo } from 'react';
import { SearchStyles } from '../meal.styles';
import { IoSearch } from 'react-icons/io5';
import Select from 'react-select';
import { Popover, PopoverContent, PopoverTrigger } from '@components/ui/popover';
import { PopoverClose } from '@radix-ui/react-popover';
import FilterDropdown from './filter-dropdown';

const SearchContent = ({
  handleSearch,
  exportMeal,
  tags,
  handleFilterChange,
  filters,
  exportMealsbyMacros,
  exportMealsAndTags,
  exportByMealIds,
  exportMealsByTags,
  exportIngredients
}) => {
  const memoizedTags = useMemo(() => {
    const tagsData = tags.map((item) =>
      item.tags.map((tag) => {
        return {
          label: tag?.name,
          value: tag._id
        };
      })
    );

    return tagsData.flat();
  }, [tags]);

  const selectedTags = useMemo(() => {
    if (!filters?.selectedTags || !Array.isArray(filters.selectedTags)) return [];
    const tagsData = memoizedTags;
    return filters.selectedTags.map((id) =>
      tagsData.find((tag) => tag.value === id)
    );
  }, [filters?.selectedTags, memoizedTags]);

  return (
    <SearchStyles>
      <div className="search">
        <IoSearch size={20} color="#64748B" />
        <input type="text" placeholder="Search" onChange={handleSearch} />
      </div>

      <div className="flex gap-4 items-center">
        <Select
          isMulti
          value={selectedTags}
          options={memoizedTags}
          className="min-w-[200px]"
          placeholder="Filter by tag name"
          onChange={(value) => {
            const id = value.map((item) => item.value);
            handleFilterChange('selectedTags', id);
          }}
        />

        <FilterDropdown handleFilterChange={handleFilterChange} filters={filters} />

        <Popover>
          <PopoverTrigger asChild>
            <div className="bg-white rounded-md border-[#E7E7E9] border p-2 shadow-sm cursor-pointer text-sm font-medium">
              Export
            </div>
          </PopoverTrigger>
          <PopoverContent
            align="end"
            className="bg-white shadow-[0px_0px_4px_2px_#0000001A] max-w-[231px] border-0 outline-0 rounded-[12px]! ring-0 p-1"
          >
            <PopoverClose
              onClick={exportMeal}
              className="p-2 text-sm font-medium text-left rounded-md transition-all duration-500 ease-in-out focus:border-0 hover:bg-[#549a9a] hover:text-white outline-none
  focus:outline-none
  focus:ring-0
  ring-0"
            >
              All Meals
            </PopoverClose>
            <PopoverClose
              onClick={exportMealsbyMacros}
              className="p-2 text-sm font-medium text-left rounded-md transition-all duration-500 ease-in-out focus:border-0 hover:bg-[#549a9a] hover:text-white outline-none
  focus:outline-none
  focus:ring-0
  ring-0"
            >
              Macros
            </PopoverClose>
            <PopoverClose
              onClick={exportMealsAndTags}
              className="p-2 text-sm font-medium text-left rounded-md transition-all duration-500 ease-in-out focus:border-0 hover:bg-[#549a9a] hover:text-white outline-none
  focus:outline-none
  focus:ring-0
  ring-0"
            >
              Meal & Tags
            </PopoverClose>
            <PopoverClose
              onClick={exportByMealIds}
              className="p-2 text-sm font-medium text-left rounded-md transition-all duration-500 ease-in-out focus:border-0 hover:bg-[#549a9a] hover:text-white outline-none
  focus:outline-none
  focus:ring-0
  ring-0"
            >
              By Ids
            </PopoverClose>
            <PopoverClose
              onClick={exportMealsByTags}
              className="p-2 text-sm font-medium text-left rounded-md transition-all duration-500 ease-in-out focus:border-0 hover:bg-[#549a9a] hover:text-white outline-none
  focus:outline-none
  focus:ring-0
  ring-0"
            >
              By Tags
            </PopoverClose>
            <PopoverClose
              onClick={exportIngredients}
              className="p-2 text-sm font-medium text-left rounded-md transition-all duration-500 ease-in-out focus:border-0 hover:bg-[#549a9a] hover:text-white outline-none
  focus:outline-none
  focus:ring-0
  ring-0"
            >
              Ingredients
            </PopoverClose>
          </PopoverContent>
        </Popover>
      </div>
    </SearchStyles>
  );
};

export default SearchContent;
